import type { DriveStep } from 'driver.js';

export const posProductsTour: DriveStep[] = [
  {
    element: '[data-tour="category-sidebar"]',
    popover: {
      title: 'Filter by Category',
      description:
        'Use these buttons to switch between Food, Beverage, Merchandise, and Service products. The active category is highlighted.',
      side: 'left',
      align: 'start',
    },
  },
  {
    element: '[data-tour="search-products"]',
    popover: {
      title: 'Search Products',
      description: 'Type here to filter products by name. Results update in real-time as you type.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="product-grid"]',
    popover: {
      title: 'Product Grid',
      description:
        'Click any product card to add it to your order. Hover over a card to see the "+" add icon. Products low on stock show a warning badge.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="cart-panel"]',
    popover: {
      title: 'Order Cart',
      description:
        'This floating panel holds your current order. Drag it anywhere on the screen by the header. Minimize it with the arrow button, or expand it to adjust quantities, add notes, and configure the order.',
      side: 'left',
      align: 'start',
    },
  },
  {
    element: '[data-tour="order-type"]',
    popover: {
      title: 'Order Type',
      description:
        'Choose Dine In, Takeout, or Delivery. Dine In shows a table selector and guest count. Delivery shows an address field.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="cart-items"]',
    popover: {
      title: 'Cart Items',
      description:
        'Adjust quantities with +/- buttons, add preparation notes to individual items, or remove items from the cart. Long press the note button to see existing notes.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="create-order-btn"]',
    popover: {
      title: 'Create Order',
      description:
        'Once your order is ready, click here to send it to the kitchen. If you selected an existing order below, this becomes "Add Items to Order" instead.',
      side: 'top',
      align: 'center',
    },
  },
];
